import { render } from "./View.vue?vue&type=template&id=bd43ae58"
import script from "./View.vue?vue&type=script&lang=ts"
export * from "./View.vue?vue&type=script&lang=ts"
script.render = render

export default script